<div class="verification-identity">



    <button *ngIf="showContentQR ||  showContentMail" mat-icon-button class="back-button" (click)="buttonBack()" tabindex="-1">
        <mat-icon class="close-icon" color="warn">arrow_back_ios</mat-icon>
    </button>
    <button mat-icon-button class="close-button" [mat-dialog-close]="true" tabindex="-1">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>


    <div *ngIf="!showContentQR && !showContentMail" @slideIn>
        <div>
            <h1 class="h1-title">Por favor, cambie a su celular</h1>
            <h3 class="desc">Seleccione la forma de continuar con la verificación:</h3>
        </div>
        <div class="container-options">

            <div class="container-box" (click)="generateQRCode()">
                <div class="number-box">
                    <mat-icon aria-hidden="false" class="large-icon" aria-label="qr_scan_incode">qr_code_2</mat-icon>
                </div>
                <div class="text-box">
                    <span class="title-option">Escanee un código QR</span>
                    <br>Continuar en su celular a través del código
                </div>
            </div>
            <!-- TODO: Descomentar cuando esté listo el endpoint -->
           <!--  <div class="container-box" (click)="sendByEmail()">
                <div class="number-box">
                    <mat-icon aria-hidden="false" class="large-icon" aria-label="send_email_incode">mail</mat-icon>
                </div>
                <div class="text-box">
                    <span class="title-option">Reciba un email</span>
                    <br>Continuar a través de un link que enviaremos a su correo
                </div>
            </div> -->

        </div>

    </div>

    <div *ngIf="showContentQR" @slideInOut>
        <div>
            <h1 class="h1-title">Escanne el código QR</h1>
            <h3 class="desc">Use la camara del celular</h3>
        </div>
        <div class="container-qr">
            <div>
                <ngx-qrcode [elementType]="elementType" [value]="value" cssClass="large-qr-code">
                </ngx-qrcode>
            </div>
            <div style="text-align: center;" *ngIf="!showErrorVerify">
                <svg class="loading-icon" viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                </svg>
                <p>Completar la verificación en el celular, por favor espere... </p>
            </div>
            
        </div>
    </div>


    <div *ngIf="showContentMail" @slideInOut>

        <div>
            <h1 class="h1-title">Continuar desde su celular</h1>
            <h3 class="desc">Revise su correo electrónico</h3>
        </div>

        <div style="text-align: center;">

            <div *ngIf="!emailSentSuccess" style="display: flex; flex-direction: column; align-items: center;">
                <svg class="loading-icon" viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                </svg>
                Enviando email...
            </div>

            <div *ngIf="emailSentSuccess">
                <img src="./assets/img/email_sending.gif" width="70%" alt="email_sending">
                <h3> Hemos enviado el link a: <b>{{ email }}</b></h3>
            </div>
            
            <!-- <svg class="success-icon" viewBox="0 0 52 52">
                <circle class="success-icon__circle" cx="26" cy="26" r="25" fill="none" />
                <path class="success-icon__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg> -->
        </div>



    </div>


</div>